"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButtonDropdown = void 0;
const react_1 = __importStar(require("react"));
const react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
const HorizontalMore_1 = require("../../../theme/icons/custom-icons/HorizontalMore");
const __1 = require("../..");
const ActionButtonDropdown_styles_1 = require("./ActionButtonDropdown.styles");
const ActionButtonDropdown = ({ items, actionHandler, openSide }) => {
    const [hide, hideMenu] = (0, react_1.useState)(true);
    return (react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: () => {
            if (!hide) {
                hideMenu(!hide);
            }
        } },
        react_1.default.createElement(__1.IconWrapper, { width: 24, height: 24, hoverEffect: true, onClick: (event) => {
                hideMenu(!hide);
                event.stopPropagation();
            } },
            react_1.default.createElement(HorizontalMore_1.HorizontalMore, null),
            react_1.default.createElement(ActionButtonDropdown_styles_1.ContentWrapper, { hidden: hide, "$openSide": openSide },
                react_1.default.createElement(__1.ContextMenu, { items: items, actionHandler: actionHandler })))));
};
exports.ActionButtonDropdown = ActionButtonDropdown;
//# sourceMappingURL=ActionButtonDropdown.js.map